import { render } from "./TimerLive.vue?vue&type=template&id=398d1ffe"
import script from "./TimerLive.vue?vue&type=script&lang=js"
export * from "./TimerLive.vue?vue&type=script&lang=js"
script.render = render

export default script